import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Referrals = () => {
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Sample data (replace with real data or fetch from API)
  const data = Array.from({ length: 57 }).map((_, index) => ({
    id: index + 1,
    referredBy: 'Anderson',
    merchantId: `BN${index + 100}`,
    name: 'Anderson',
    email: `anderson${index}@gmail.com`,
    mobile: '+91 93456 90554',
    status: 'Success',
    activatedOn: '26 Jul, 2024, 6:53 19',
  }));

  const startIndex = (currentPage - 1) * limit;
  const paginatedData = data.slice(startIndex, startIndex + limit);
  const totalPages = Math.ceil(data.length / limit);

  return (
    <main className="main-content">
      <div>
        {/* Main Content */}
        <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
          <h2 className="text-xl font-semibold text-gray-800">Referrals</h2>

          <nav>
            <ol className="flex items-center gap-1.5 mr-7">
              <li>
                <Link
                  className="inline-flex items-center gap-1.5 text-sm text-black"
                  to="/dashboard"
                >
                  Home /
                </Link>
              </li>
              <li className="text-sm text-gray-800">Referrals</li>
            </ol>
          </nav>
        </div>

        {/* Main content */}
        <div className="mx-auto p-4 md:p-4">
          <div className="space-y-5 sm:space-y-6">
            <div className="rounded-2xl border border-gray-200 bg-white">
              <div className="px-5 py-4 sm:px-6 sm:py-5">
                <h3 className="text-base font-medium text-gray-800"></h3>
                 {/* Limit selector */}
                 <div className="flex items-center gap-2">
                    <label className="text-sm text-gray-700">Rows per page:</label>
                    <select
                      className="border border-gray-300 rounded px-2 py-1 text-sm"
                      value={limit}
                      onChange={(e) => {
                        setLimit(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      {[10, 20, 50, 100].map((val) => (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      ))}
                    </select>
                  </div>
              </div>
              <div className="p-5 border-t border-gray-100 sm:p-6">
                {/* Table */}
                
                <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
                  <div className="max-w-full overflow-x-auto">
                    <table className="min-w-full">
                      {/* Table header */}
                      <thead>
                        <tr className="text-white border-b border-gray-100" style={{ backgroundColor: '#635BFF' }}>
                          <th className="px-5 py-3 sm:px-6">SI.No</th>
                          <th className="px-5 py-3 sm:px-6">Referred by</th>  
                          <th className="px-5 py-3 sm:px-6">Merchant ID</th>
                          <th className="px-5 py-3 sm:px-6">Name</th>
                          <th className="px-5 py-3 sm:px-6">Email</th>
                          <th className="px-5 py-3 sm:px-6">Mobile</th>
                          <th className="px-5 py-3 sm:px-6">Status</th>
                          <th className="px-5 py-3 sm:px-6">Activated On</th>
                        </tr>
                      </thead>

                      {/* Table body */}
                      <tbody className="divide-y divide-gray-100">
                        {paginatedData.map((row, index) => (
                          <tr key={row.id} className="whitespace-nowrap">
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{startIndex + index + 1}</td>
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{row.referredBy}</td>
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{row.merchantId}</td>
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{row.name}</td>
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{row.email}</td>
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{row.mobile}</td>
                            <td className="px-5 py-4 sm:px-6">
                              <span className="rounded-full bg-[#047A48] px-2 py-0.5 text-sm font-medium text-white">
                                {row.status}
                              </span>
                            </td>
                            <td className="px-5 py-4 sm:px-6 text-black text-sm">{row.activatedOn}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination & Limit Control */}
                <div className="flex justify-end items-end mt-4 px-2">
                  {/* Limit selector
                  <div className="flex items-center gap-2">
                    <label className="text-sm text-gray-700">Rows per page:</label>
                    <select
                      className="border border-gray-300 rounded px-2 py-1 text-sm"
                      value={limit}
                      onChange={(e) => {
                        setLimit(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      {[10, 20, 50, 100].map((val) => (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      ))}
                    </select>
                  </div> */}

                  {/* Page navigation */}
                  <div className="flex items-center gap-2">
                    <button
                      className="px-2 py-1 text-sm border rounded"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>
                    {[...Array(totalPages)].map((_, i) => (
                      <button
                        key={i}
                        className={`px-2 py-1 text-sm border rounded ${
                          currentPage === i + 1 ? 'bg-blue-500 text-white' : ''
                        }`}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                    <button
                      className="px-2 py-1 text-sm border rounded"
                      onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>

                {/* End Table */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Referrals;
